import { useEffect, useState } from "react"
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, DropdownStatusList, EmptyString } from "utils/Constant"
import { ApiGetDashboardInfo } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker";

export default function Transaction(){
    let navigate = useNavigate()
    
    const { data: dashboardInfo, fetch: getRoomInfo } = useFetch(ApiGetDashboardInfo)

    const [options, setOptions] = useState([
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
        {label: "asd", value: "1"},
    ])

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState(false)
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    const [transactionType, setTransactionType] = useState('OnUs');

    const handleChange = (event) => {
        setTransactionType(event.target.value);
    };

    useEffect(() => {
        // setLoading(true)

        // Promise.all([
        //     fGetRoomInfo()
        // ]).then(() => {
        //     setLoading(false)
        // })
    }, [])

    async function fGetRoomInfo(){
        await getRoomInfo({
            data: {
                kostId: localStorage.getItem("KostId")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }

    function fPaymentReceivedClick(paymentId){
        navigate("/kost/payment/form?paymentId=" + paymentId + "&formType=Edit")
    }
    function fBookingClick(bookingId){
        navigate("/kost/booking/form?bookingId=" + bookingId + "&formType=Edit")
    }
   

    return(
        <div className="flex flex-col gap-2">
            <div>
                <span className="font-semibold text-2xl">Transaction</span>
            </div>
            <hr />
            
            <div className="flex flex-col sm:flex-row mt-8 gap-8">
                <div className="border rounded-md p-4 w-6/12 bg-white flex flex-col shadow-md">
                    <div className="">
                        <span className="font-semibold">Enter Card Number</span>
                        <hr className="mt-2" />
                    </div>
                    <div className="mt-4">
                        <div>
                            <Select options={options} />
                        </div>
                    </div>
                </div>

                <div className="border rounded-md p-4 max-w-6/12 bg-white flex flex-col shadow-md">
                    <div>
                        <span className="font-semibold">Transaction Form</span>
                        <hr className="mt-2" />
                    </div>
                    <div className="mt-4 flex flex-col gap-4">
                        <div className="flex items-center">
                            <div className="w-48">
                                <span>Tanggal Transaksi</span>
                            </div>
                            <div className="px-2">
                                <span>:</span>
                            </div>
                            <div className="w-72">
                                <DatePicker className="w-full h-10" />
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="w-48">
                                <span>Mesin</span>
                            </div>
                            <div className="px-2">
                                <span>:</span>
                            </div>
                            <div className="w-72">
                                <Select options={options} />
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="w-48">
                                <span>Tipe</span>
                            </div>
                            <div className="px-2">
                                <span>:</span>
                            </div>
                            <div className="flex gap-4 items-center w-72">
                                <label className="flex gap-2">
                                    <input type="radio" value="OnUs" checked={transactionType === 'OnUs'} onChange={handleChange} />
                                    On Us
                                </label>
                                <label className="flex gap-2">
                                    <input type="radio" value="OffUs" checked={transactionType === 'OffUs'} onChange={handleChange} />
                                    Off Us
                                </label>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="w-48">
                                <span>Jumlah Gesek</span>
                            </div>
                            <div className="px-2">
                                <span>:</span>
                            </div>
                            <div className="w-72">
                                <input className="input" />
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="w-48">
                                <span>MDR</span>
                            </div>
                            <div className="px-2">
                                <span>:</span>
                            </div>
                            <div className="w-72">
                                <input className="input" />
                            </div>
                        </div>
                        <div className="flex items-center">
                            <div className="w-48">
                                <span>Jumlah Uang Diterima</span>
                            </div>
                            <div className="px-2">
                                <span>:</span>
                            </div>
                            <div className="w-72">
                                <input className="input" />
                            </div>
                        </div>

                        <div className="flex items-center">
                            <button className="px-4 py-2 bg-lime-600 rounded">
                                <span>Gesek</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col sm:flex-row mt-8 gap-8">
                <div className="border rounded-md p-4 w-full h-auto max-h-[400px] overflow-hidden bg-white flex flex-col shadow-md">
                    <div>
                        <span className="font-semibold">Payment Received This Month</span>
                        <hr className="mt-2" />
                    </div>
                    <div className="mt-4 overflow-auto">
                        <table className="w-full border rounded-md">
                            <thead className="">
                                <tr className="h-12">
                                    <th className="font-semibold text-left px-2">Room</th>
                                    <th className="font-semibold text-left px-2">Tenant</th>
                                    <th className="font-semibold text-left px-2">Payment Date</th>
                                    <th className="font-semibold text-left px-2">Payment Type</th>
                                </tr>
                            </thead>
                            <tbody className="border">
                                {dashboardInfo?.data?.paymentThisMonth?.map((data, i) => {
                                    return(
                                        <tr className="my-2 row h-10 border-y cursor-pointer hover:bg-slate-100" key={ i } onClick={() => { fPaymentReceivedClick(data.paymentId) }}>
                                            <td className="px-2">
                                                <span>{ data.roomNumber }</span>
                                            </td>
                                            <td className="px-2">
                                                <span>{ data.tenantName }</span>
                                            </td>
                                            <td className="px-2">
                                                <span>{ moment(data.paymentDate).format("DD MMM yyyy") }</span>
                                            </td>
                                            <td className="px-2">
                                                <span>{ data.paymentType }</span>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="border rounded-md p-4 w-full h-auto max-h-[400px] overflow-hidden bg-white flex flex-col shadow-md">
                    <div>
                        <span className="font-semibold">Unpaid Room (Tenant) This Month</span>
                        <hr className="mt-2" />
                    </div>
                    <div className="mt-4 overflow-auto">
                        <table className="w-full border rounded-md sticky">
                            <thead>
                                <tr className="h-12">
                                    <th className="font-semibold text-left px-2">Room</th>
                                    <th className="font-semibold text-left px-2">Tenant</th>
                                </tr>
                            </thead>
                            <tbody className="border">
                                {dashboardInfo?.data?.unpaidBooking?.map((data, i) => {
                                    return(
                                        <tr className="my-2 row h-10 border-y" key={ i }>
                                            <td className="px-2">
                                                <span>{ data.roomNumber }</span>
                                            </td>
                                            <td className="px-2">
                                                <span>{ data.tenantName }</span>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading ? (<LoadingModal />) : (<div />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}